const EVENT_NAMES = ["MARRIAGE", "BIRTH OF BABY", "ADOPTION OR PLACEMENT FOR ADOPTION OF A CHILD", "OTHERS"];

export default EVENT_NAMES;
